import { useState, useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";
import "./Eventos.css";
import BienvenidaEvento from "./assets/img/imagenes eventos/BienvenidaEvento.jpeg";
import ImgEvento from "./assets/img/imagenes home/ImgEvento.jpeg";
import AppCardEvente from "../components/AppCardEvente";
import { getEventos, getConfigPagina, isApiConfigured } from "../services/api";
import ContenidoExtra from "../components/ContenidoExtra";

const defaultEventos = Array(8).fill({ img: ImgEvento, desc: "" });

const DEFAULT_TITULO = "¡El escenario es tuyo!";
const DEFAULT_DESC = "En un vibrante escenario que combina animación digital y magia teatral, Ben, el elefante más curioso del campamento, se embarca en una misión vital: convertirse en un Guardián del Planeta. Un viaje musical diseñado para inspirar a la Generación Alpha a cuidar su entorno a través de la acción y la alegría.";

const DEFAULT_INFO_TITULO = "Más que un show, una misión colectiva";
const DEFAULT_INFO_TEXTO = "\"El Gran Día de Ben\" traslada los valores educativos de la serie animada a un formato presencial interactivo. Aprovechamos el reconocimiento de marca de la serie para crear un evento de alta demanda familiar.";
const DEFAULT_DIF_TITULO = "Diferenciadores";
const DEFAULT_FRASE_FINAL = "Espera muy pronto las fechas y lugares dónde nos estaremos presentando.";
const DEFAULT_CATALOGO_TITULO = "Eventos";
const DEFAULT_CATALOGO_SUBTITULO = "Nuestros próximos eventos";
const DEFAULT_VACIO_TITULO = "Próximamente";
const DEFAULT_VACIO_TEXTO = "Estamos preparando nuevas fechas para que vivas la magia de Balloon & Ben en vivo. Vuelve pronto y únete a la misión de cuidar el planeta.";

const defaultDiferenciadores = [
  {
    titulo: "Edu-entretenimiento",
    texto: "Mensaje ecológico urgente: microplásticos, reciclaje y la importancia de las abejas.",
  },
  {
    titulo: "Interacción activa",
    texto: "El público no es espectador; es nombrado \"Guardián del Planeta\".",
  },
  {
    titulo: "Hit-Factor",
    texto: "Canciones originales diseñadas para el engagement post-show.",
  },
];

function Eventos() {
  const [eventos, setEventos] = useState(defaultEventos);
  const [hasRealEvents, setHasRealEvents] = useState(false);
  const [config, setConfig] = useState({
    titulo: null,
    subtitulo: null,
    imagen: null,
    contenido_extra: null,
    eventos_info_titulo: null,
    eventos_info_texto: null,
    eventos_dif_titulo: null,
    eventos_diferenciadores: [],
    eventos_frase_final: null,
    eventos_catalogo_titulo: null,
    eventos_catalogo_subtitulo: null,
    eventos_vacio_titulo: null,
    eventos_vacio_texto: null,
  });
  const diferenciadores = config.eventos_diferenciadores?.length > 0
    ? config.eventos_diferenciadores
    : defaultDiferenciadores;
  const shouldReduceMotion = useReducedMotion();

  const sectionVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0.2 : 0.6,
        ease: [0.22, 1, 0.36, 1],
        staggerChildren: shouldReduceMotion ? 0 : 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 24 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: shouldReduceMotion ? 0.2 : 0.5, ease: "easeOut" },
    },
  };

  useEffect(() => {
    if (!isApiConfigured()) return;
    getEventos()
      .then((data) => {
        if (data && data.length > 0) {
          setHasRealEvents(true);
          setEventos(data.map((e) => ({
            img: e.imagen || ImgEvento,
            desc: e.titulo || "",
            descripcion: e.descripcion || "",
            id: e.id,
            fecha: e.fecha || null,
            lugar: e.lugar || null,
            hora: e.hora || null,
          })));
        }
      })
      .catch(() => {});
    getConfigPagina("eventos")
      .then((cfg) => { if (cfg) setConfig(cfg); })
      .catch(() => {});
  }, []);

  return (
    <div className="eventos">

      {/* ── HERO ── */}
      <motion.section
        className="eventos-hero"
        initial="hidden"
        animate="show"
        variants={sectionVariants}
      >
        <motion.h1 className="eventos-title" variants={itemVariants}>
          {config.titulo || DEFAULT_TITULO}
        </motion.h1>
        <motion.div className="eventos-hero__imagen" variants={itemVariants}>
          <img
            src={config.imagen || BienvenidaEvento}
            alt="Evento Balloon y Ben"
            className="img-eventos"
          />
        </motion.div>
        <motion.p className="eventos-descripcion" variants={itemVariants}>
          {config.subtitulo || DEFAULT_DESC}
        </motion.p>
        <ContenidoExtra html={config.contenido_extra} variants={itemVariants} />
      </motion.section>

      {/* ── INFO DEL SHOW ── */}
      <motion.section
        className="eventos-info"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={sectionVariants}
      >
        <motion.div className="eventos-info__intro" variants={itemVariants}>
          <h2 className="eventos-info__titulo">{config.eventos_info_titulo || DEFAULT_INFO_TITULO}</h2>
          <p className="eventos-info__texto">
            {config.eventos_info_texto || DEFAULT_INFO_TEXTO}
          </p>
        </motion.div>

        <motion.h3 className="eventos-dif-heading" variants={itemVariants}>
          {config.eventos_dif_titulo || DEFAULT_DIF_TITULO}
        </motion.h3>

        <div className="eventos-dif-grid">
          {diferenciadores.map((dif) => (
            <motion.div key={dif.titulo} className="eventos-dif-card" variants={itemVariants}>
              <span className="eventos-dif-card__icono" />
              <h4>{dif.titulo}</h4>
              <p>{dif.texto}</p>
            </motion.div>
          ))}
        </div>

        <motion.p className="eventos-dif__pronto" variants={itemVariants}>
          {config.eventos_frase_final || DEFAULT_FRASE_FINAL}
        </motion.p>
      </motion.section>

      {/* ── CATÁLOGO DE EVENTOS ── */}
      <motion.section
        className="eventos-catalogo"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.15 }}
        variants={sectionVariants}
      >
        <motion.div className="eventos-catalogo__header" variants={itemVariants}>
          <h2 className="evento-evento">{config.eventos_catalogo_titulo || DEFAULT_CATALOGO_TITULO}</h2>
          <p className="evento-subEvento">{config.eventos_catalogo_subtitulo || DEFAULT_CATALOGO_SUBTITULO}</p>
        </motion.div>

        {hasRealEvents ? (
          <motion.div className="eventos-grid" variants={itemVariants}>
            {eventos.map((evento, index) => (
              <AppCardEvente
                key={evento.id || index}
                img={evento.img}
                desc={evento.desc}
                descripcion={evento.descripcion || ""}
                fecha={evento.fecha}
                lugar={evento.lugar}
                hora={evento.hora}
                eventoId={evento.id || undefined}
              />
            ))}
          </motion.div>
        ) : (
          <motion.div className="eventos-vacio" variants={itemVariants}>
            <div className="eventos-vacio__card">
              <h3 className="eventos-vacio__titulo">{config.eventos_vacio_titulo || DEFAULT_VACIO_TITULO}</h3>
              <p className="eventos-vacio__texto">
                {config.eventos_vacio_texto || DEFAULT_VACIO_TEXTO}
              </p>
            </div>
          </motion.div>
        )}
      </motion.section>

    </div>
  );
}

export default Eventos;
